import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { ApplySignedFormat } from "components/app/ApplySignedFormat";
import { AppContext } from "components/app/RemExprertProvider";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Pager from "components/ui/controls/pager/pager";
import TextField from "components/ui/controls/text-field/text-field";
import Modal from "components/ui/modal/modal";
import { applyFormat } from "components/ui/ui-helpers";
import React, { useContext, useState } from "react";
import { FaCalculator, FaEdit, FaGlobe, FaMoneyBillWave, FaBuilding, FaDollarSign, FaFileInvoiceDollar, FaPiggyBank, FaChartLine } from "react-icons/fa";
import ModalParamDividendes from "./ModalParamDividendes";
import { CompactFinancialOptiRem } from "../Resultat/CompactFinancialCard";

function RemExpressOptimisationResAvtIS(props) {
  const { Periode } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [modalResultatEntreprise, setmodalResultatEntreprise] = useState(false);
  return (
    <CardBox className="blockRoundedForce" bpad>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px", width: "100%" }}>

        <CompactFinancialOptiRem
          icon={<FaChartLine />}
          title="Résultat avant IS"
          valueOrigine={applyFormat(Periode?.ResAvtIs, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={context.state["OptiRemResAvtIs"]}
          isEditable={true}
          onChange={(e) => {
            context.handleCalculOptiRem("res_avant_is", "OptiRemResAvtIs", "", ResultatTNS, false, e);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemResAvtIs"]) - Number(Periode?.ResAvtIs))}
          accentColor="#059669"
        />
        <CompactFinancialOptiRem
          icon={<FaBuilding />}
          title="Impôt sur les sociétés"
          valueOrigine={applyFormat(Periode?.ImpotSoc, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={applyFormat(context.state["OptiRemImpotSoc"], "uint", { thousands: " ", decimal: ",", unit: " €" })}
          onEdit={() => {
            setmodalResultatEntreprise(true);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemImpotSoc"]) - Number(Periode?.ImpotSoc))}
          accentColor="#dc2626"
        />
        <CompactFinancialOptiRem
          icon={<FaPiggyBank />}
          title={`Mise en réserve${Periode?.DividendeBrutAutres !== 0 ? " / div. autres associés" : ""}`}
          valueOrigine={applyFormat(Number(Periode?.Reserve) + Number(Periode?.DividendeBrutAutres), "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={applyFormat(Number(context.state["OptiRemReserve"]) + Number(context.state["OptiRemDivAutres"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemReserve"]) + Number(context.state["OptiRemDivAutres"]) - (Number(Periode?.Reserve) + Number(Periode?.DividendeBrutAutres)))}
          accentColor="#7c3aed"
        />
        <CompactFinancialOptiRem
          icon={<FaDollarSign />}
          title="Dividendes bruts"
          valueOrigine={applyFormat(Periode?.DividendeBrut, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={context.state["OptiRemDividendeBrut"]}
          isEditable={true}
          onChange={(e) => {
            context.handleCalculOptiRem("dividende_brut", "OptiRemDividendeBrut", "", ResultatTNS, false, e);
          }}
          valueEcart={ApplySignedFormat(Number(context.state["OptiRemDividendeBrut"]) - Number(Periode?.DividendeBrut))}
          accentColor="#2563eb"
        />
      </div>

      <Modal
        width="80%"
        height="80%"
        title="Situation professionnelle"
        icon={<FaGlobe />}
        visible={modalResultatEntreprise}
        onClose={() => {
          context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs", "", ResultatTNS,false, context.state["OptiRemResAvtIs"]);
          setmodalResultatEntreprise(false);
        }}
      >
       <Pager
        pages={[
          {
            label: "Dividendes",
            icon: <FaMoneyBillWave />,
            content: <ModalParamDividendes Outil={"OptiRem"} />,
          },
        ]}
        page={0}
        navButtons={{
          // cancel: {
          //   onClick: (evt) => {
          //     setmodalResultatEntreprise(false);
          //   },
          // },
          // previous: {},
          // next: {},
          validate: {
            onClick: (evt) => {
              context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs", "", ResultatTNS,false, context.state["OptiRemResAvtIs"]);
              setmodalResultatEntreprise(false);
            },
          },
        }}
      />
      </Modal>
    </CardBox>
  );
}
export default RemExpressOptimisationResAvtIS;
